import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { PageHeader, StatCard, Section } from "../../components/Common";
import { useAuth } from "../../lib/auth";
import { Link } from "react-router-dom";
import { ClipboardList, BookOpen, CalendarCheck, Users } from "lucide-react";

export default function TeacherOverview() {
  const { user } = useAuth();
  const [batches, setBatches] = useState([]);
  const [tests, setTests] = useState([]);
  const [hw, setHw] = useState([]);

  useEffect(() => {
    (async () => {
      const [b, t, h] = await Promise.all([
        api.get("/teacher/batches"),
        api.get("/tests"),
        api.get("/homework"),
      ]);
      setBatches(b.data);
      setTests(t.data);
      setHw(h.data);
    })();
  }, [user.id]);

  return (
    <div>
      <PageHeader title={`Hi, ${user.name.split(" ")[0]} 👋`} subtitle="Your classes at a glance" testId="teacher-overview" />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard label="My batches" value={batches.length} icon={Users} />
        <StatCard label="Tests" value={tests.length} icon={ClipboardList} accent="mint" />
        <StatCard label="Homework" value={hw.length} icon={BookOpen} accent="yellow" />
        <StatCard label="Today" value={new Date().toLocaleDateString()} sub="Mark attendance" icon={CalendarCheck} accent="coral" />
      </div>

      <div className="mt-8 grid lg:grid-cols-2 gap-6">
        <Section title="My batches">
          <div className="space-y-2">
            {batches.map((b) => (
              <div key={b.id} className="flex items-center justify-between p-3 rounded-lg hover:bg-slate-50">
                <div>
                  <div className="font-semibold text-slate-900">{b.name}</div>
                  <div className="text-xs text-slate-500">{b.subject}</div>
                </div>
                <Link to="/dashboard/teacher/attendance" className="text-sm font-semibold text-blue-600 hover:underline">Open →</Link>
              </div>
            ))}
            {batches.length === 0 && <p className="text-sm text-slate-500">No batches assigned yet. Ask admin to assign you to a batch.</p>}
          </div>
        </Section>

        <Section title="Quick actions">
          <div className="grid grid-cols-2 gap-3">
            <Link to="/dashboard/teacher/attendance" className="p-4 rounded-lg bg-blue-50 hover:bg-blue-100 transition-colors">
              <CalendarCheck className="h-5 w-5 text-blue-600" />
              <div className="mt-2 font-semibold text-slate-900">Mark attendance</div>
            </Link>
            <Link to="/dashboard/teacher/tests" className="p-4 rounded-lg bg-emerald-50 hover:bg-emerald-100 transition-colors">
              <ClipboardList className="h-5 w-5 text-emerald-600" />
              <div className="mt-2 font-semibold text-slate-900">Create test</div>
            </Link>
            <Link to="/dashboard/teacher/homework" className="p-4 rounded-lg bg-amber-50 hover:bg-amber-100 transition-colors">
              <BookOpen className="h-5 w-5 text-amber-600" />
              <div className="mt-2 font-semibold text-slate-900">Add homework</div>
            </Link>
            <Link to="/dashboard/teacher/chat" className="p-4 rounded-lg bg-rose-50 hover:bg-rose-100 transition-colors">
              <Users className="h-5 w-5 text-rose-600" />
              <div className="mt-2 font-semibold text-slate-900">Chat parents</div>
            </Link>
          </div>
        </Section>
      </div>
    </div>
  );
}
